module.exports = __webpack_public_path__ + "media/scholarship_winners/arlene-r-3d61ccfd.png";